import comp from "./RelatedConcepts";
export default comp;
